const capturedReturnUrl = new URLSearchParams(window.location.search).get('return_url');

const ALLOWED_HOSTNAMES = ['localhost', '127.0.0.1', 'bookdoc.com'];

export function getReturnUrl(): string | null {
  if (!capturedReturnUrl) {
    return null;
  }

  try {
    const url = new URL(capturedReturnUrl);

    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return null;
    }

    const isAllowedHost = ALLOWED_HOSTNAMES.includes(url.hostname) || url.hostname.endsWith('.bookdoc.com');

    return isAllowedHost ? capturedReturnUrl : null;
  } catch {
    return null;
  }
}
